import React, { useState, useEffect, useRef } from 'react'; //, useRef
import styled from 'styled-components';
import { RemoveScroll } from 'react-remove-scroll';
import { PopupWrapped, ContentWrapper } from '../../general_components/popup_manager/popupManager';
import { LoadingFrame } from '../../main_board_components/teamCard/truckCard/truckCardComponents/popupWindow';
import { CustomLoadingIcon } from '../../supplementary_components/loading_icon';
import { sendRequest, API_ROOT } from '../../supplementary_components/requests';
import { SingleStatementContentManager } from './singleStatementManager';
import { addPopup } from '../../supplementary_components/store';
import { ConfirmationDialogue } from '../../general_components/forms/ConfirmationDialogue';


const StatmentWrapper = styled.div`
    white-space:nowrap;
    overflow:scroll;
    padding: 2rem;
    &>:not(:first-child){
        margin-top:2rem;
    }
    
`


export const StatementsPopup = ({data, companyData, setOpenStatementsByDrivers, changeStatementStatus, updateStatementNote}) => {    
    const [loadedStatements, setLoadedStatements] = useState(null);
    const [loadeding, setLoading] = useState(true);
    const statementsContainer = useRef(null);
    const _setData=(newData)=>{
        setLoading(false);
        newData.sort((a, b) => {
            return data.driverIds.indexOf(a.driver.id) - data.driverIds.indexOf(b.driver.id);
        });
        setLoadedStatements(newData);
    }
    useEffect(
        () => {
            if(data.defaultStatementsArray){
                _setData(data.defaultStatementsArray);
            }else if(loadedStatements === null){
                setLoading(true);
                const controller = new AbortController();
                const signal = controller.signal;
                
                sendRequest('GET', API_ROOT+`statements/byByDriverIds?driverIds=${data.driverIds}&periodId=${data.periodId}`, signal, _setData, ()=>{
                    setLoadedStatements(undefined)
                }, null);
                return () => {
                    controller.abort();
                };
            }
        // eslint-disable-next-line
        }, [data]
    );
    function closePopup(){
        setLoadedStatements(null);
        setOpenStatementsByDrivers(null);
    }
    return <RemoveScroll>
            <PopupWrapped data-closable={false}
            
            onMouseDown={(e)=>{
                e.target.setAttribute("data-closable", true);
            }} 
            onClick={(e)=>{
                
                if(e.target.dataset.closable === 'true'){
                    let hasUnsavedChanges = false;
                    if(statementsContainer && statementsContainer.current){
                        for(let wrapper of statementsContainer.current.childNodes){
                            for(let statement of wrapper.childNodes){
                                if(statement.id && statement.id !== null && statement.id !== ''){
                                    if(statement.dataset.unsavedchanges === "true"){
                                        hasUnsavedChanges = true;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    
                    if(hasUnsavedChanges){
                        addPopup({
                            content: ConfirmationDialogue,
                            popupData:{
                                action:(postResultAction)=>{
                                    closePopup()
                                    postResultAction(true);
                                },
                                name: "Close",
                                formTitle:"Close Statement",
                                submitTitle:"Continue",
                                message:"You have unsaved changes. Are you sure you want to continue?",
                                postSuccessAction: ()=>{
                                },
                                EZCloseAllowed:true
                            }
                        });
                    }else{
                        closePopup()
                    }
                }
            }} >
                <ContentWrapper style={{height:"fit-content", maxHeight: "100%", overflowY:"scroll"}} className="no-scrollbar" $customBackground={"none"} onClick={e=>e.stopPropagation()} $customWidth={"98%"} $customMaxWidth={"1600px"} $customMinWidth={"780px"} >
                    {loadeding?
                    <LoadingFrame >
                        <CustomLoadingIcon height={'2.5rem'} speed={1.0} strokeColor="white" />
                    </LoadingFrame>:null}
                    {loadedStatements ?
                    <StatmentWrapper ref={statementsContainer}>
                        {
                            loadedStatements.map((statement, index)=>{
                                return <SingleStatementContentManager key={index} crntStatement={statement}  companyData={companyData} close={closePopup} changeStatementStatus={changeStatementStatus} updateStatementNote={updateStatementNote} />
                            })
                        }
                    </StatmentWrapper>
                    : 
                    loadedStatements === undefined ?
                    <div className='errorMessage'>{"Something went wrong"}</div>
                    :null
                    }
                </ContentWrapper>
                
            </PopupWrapped>
        </RemoveScroll>
}